module.exports = __webpack_public_path__ + "static/media/WebIcon.c88c6c06.svg";